var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-view"},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":_vm.$env.getAppLogo().logo}}),_c('ActionButton',{staticStyle:{"margin-top":"2rem"},attrs:{"label":"BUTTON_BACK"},on:{"click":_vm.backToApp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }